import { render, staticRenderFns } from "./topicForm.vue?vue&type=template&id=6e5753e4&scoped=true"
import script from "./topicForm.vue?vue&type=script&lang=js"
export * from "./topicForm.vue?vue&type=script&lang=js"
import style0 from "./topicForm.vue?vue&type=style&index=0&id=6e5753e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5753e4",
  null
  
)

export default component.exports